import { PlaybackRateButton as PlaybackRateButton$1 } from "../../../../../ui/playback-rate-button/component.js";
import { Button } from "./button.js";
import { jsx } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/buttons/playback-rate-button.tsx
/** @jsxImportSource react */
function PlaybackRateButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsx(PlaybackRateButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-playback-rate-button", resolveClassName(className, state)),
		...props
	});
}
//#endregion
export { PlaybackRateButton };

//# sourceMappingURL=playback-rate-button.js.map